import React from "react";
import ReactEcharts from "echarts-for-react";

export default function Horizontalbar({
  data,
  yAxisLabel,
  grid,
  legend,
  xAxis: xAxisProp,
  yAxis: yAxisProp,
}) {
  
  function formatCurrency(num, currency = "USD") {
  if (num === null || num === undefined) return "";

  // Handle large numbers
  let formatted;
  if (Math.abs(num) >= 1.0e9) {
    formatted = (num / 1.0e9).toFixed(2) + "B";
  } else if (Math.abs(num) >= 1.0e6) {
    formatted = (num / 1.0e6).toFixed(2) + "M";
  } else if (Math.abs(num) >= 1.0e3) {
    formatted = (num / 1.0e3).toFixed(2) + "K";
  } else {
    formatted = num.toFixed(2) ;
  }

  // Add currency symbol using Intl
  const symbol = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  })
    .formatToParts(0)
    .find(p => p.type === "currency").value;

  return symbol + formatted;
}

  const option = {
    tooltip: {
      show: true,
      trigger: "axis",
      axisPointer: {
        type: "shadow"
      },
      formatter: (params) => {
        const [param] = params;
        const { data: item } = param ?? {};
        return `
      <b>Department : ${item?.DEPARTMENT}</b><br/>
      Budget : ${item?.BUDGET_LABEL || "-"} / ${item?.BUDGET_PERCENTAGE || "-"}%<br/>
      Expense: ${formatCurrency(item?.ACTUAL_SPEND) || "-"} /  ${item?.ACTUAL_SPEND_PERCENTAGE || "-"}%<br/>
      Obligation: ${item?.ENCUMBRANCE_LABEL || "-"} / ${item?.ENCUMBRANCE_PERCENTAGE || "-"}%
    `;
      }
    },
    legend: legend,
    grid: grid,
    xAxis: {
      type: "value",
      splitLine: {
        show: false,
      },
      axisLabel: {
        show: false,
      },
      ...xAxisProp, // override or extend defaults with props
    },
    yAxis: {
      type: "category",
      data: data.map(({ DEPARTMENT }) => DEPARTMENT),
      axisLabel: yAxisLabel,
      axisLine: {
        show: false,
      },
      axisTick: {
        show: false,
      },
      ...yAxisProp, // override or extend defaults with props
    },
    data: [1087, 1977, 3178, 2500],
        label: {
          show: false,
          position: "outside",
          color: "#000",
          fontSize: 12,
          align: "left",
        },
    

    series:
      // seriesData
      [
        {
          name: "Budget",
          type: "bar",
          barMinWidth: 30,
          barMaxWidth: 40,
          label: {
            show: true,
            position: "outside",
            color: "#000",
            fontSize: 12,
            align: "left",
            formatter: ({ data }) => data?.BUDGET_LABEL
          },
          itemStyle: {
            color: "#BCBCBC",
          },
          data: data?.map((row) => {
            return {
              ...row,
              value: row?.BUDGET
            }
          }),
          emphasis: {
            "disabled": true,
          },
        },
        {
          name: "Expense",
          type: "bar",
          stack: "overlap",
          barMaxWidth: 20,
          barGap: "-75%",
          itemStyle: {
            color: "#7C2F3E",
          },
          data: data.map(({ ACTUAL_SPEND }) => ACTUAL_SPEND),
          label: {
            show: false,
            position: "outside",
            color: "#000",
            fontSize: 12,
            align: "left",
          },
          emphasis: {
            "disabled": true,
          },
          tooltip: {
            show: false
          }
        },
        {
          name: "Obligation",
          type: "bar",
          barMaxWidth: 20,
          barGap: "-75%",
          stack: "overlap",
          itemStyle: {
            color: "#B9814D",
          },
          data: data.map(({ ENCUMBRANCE }) => ENCUMBRANCE),
          label: {
            show: false,
            position: "outside",
            color: "#000",
            fontSize: 12,
            align: "left",
          },
          emphasis: {
            "disabled": true,
          },
          tooltip: {
            show: false
          }
        },
       
      {
        name: "CNT 20",
        type: "bar",
        barWidth: "35%",
        stack: "overlap",
        itemStyle: {
          color: "#B9814D",
        },
        data: [150, 55, 120, 45],
        label: {
          show: false,
          position: "outside",
          color: "#000",
          fontSize: 12,
          align: "left",
        },
      },
       
      
    ],
  };

  return (
    <ReactEcharts
      option={option}
      opts={{ renderer: "svg" }}
      style={{ width: "100%", height: "100%" }}
    />
  );
}
